<template>
  <div>
    <footer
      class="footer"
      v-if="
        $store.getters['auth/isRole']('ROLE_AGENT') == true ||
        $store.getters['auth/isRole']('ROLE_ADMIN') == true ||
        $store.getters['auth/isRole']('ROLE_SUPER_ADMIN') == true
      "
    >
      <div class="footer__top">
        <div class="footer__top-container">
          <div class="footer__logo-container">
            <img class="footer__logo" alt="" src="/static/img/logo.svg" />
          </div>
          <div class="footer__address">
            <p>Contact</p>
            <ul>
              <li><strong>Magasin Central</strong></li>
              <li>4 Rue des Bas champs</li>
              <li>45 380 La Chapelle-Saint-Mesmin</li>
            </ul>
          </div>
          <div class="footer__links">
            <ul>
              <!-- <li><a href="">Plan du site</a></li>
              <li><a href="">Des questions ?</a></li>
              <li><a href="">CGV</a></li> -->
            </ul>
          </div>
          <div class="footer__signature">
            <span>Réalisation : kromi.fr</span>
          </div>
        </div>
      </div>
      <div class="footer__bottom">
        <div class="footer__baseline-container baseline">
          <img class="baseline__logo" src="/static/img/MCI-RVB.svg" />
        </div>
      </div>
    </footer>
    <footer
      class="footer footer--mobile"
      v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true"
    >
      <div class="footer__top">
        <div class="footer__top-container">
          <div class="footer__signature">
            <span>Réalisation : kromi.fr</span>
          </div>
        </div>
      </div>
      <div class="footer__bottom">
        <div class="footer__baseline-container baseline">
          <img class="baseline__logo" src="/static/img/MCI-RVB.svg" />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { languages_trad } from "@/traductions/config";
import { defaultLocale } from "@/traductions/config";

export default {
  name: "Footer",
  data() {
    return {
      locale: this.$i18n.locale,
      languages: languages_trad,
      role: "tech",
    };
  },
  computed: {},
  watch: {
    locale(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("defaultLocale", lang);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.iziToast-wrapper {
  .iziToast-capsule {
    background: red;
    .toastr-mci {
      border: none !important;
    }
  }
}

.footer {
  z-index: 10;
  position: relative;
  margin-top: 80px;
  &__top {
    background-color: $color1;
    padding: 40px 0;
  }
  &__top-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
  }
  &__logo {
    width: 110px;
  }
  &__bottom {
    padding: 20px 0;
    background-color: white;
  }
  &__logo-container {
    width: 20%;
    text-align: right;
    padding-right: 20px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }
  &__address {
    width: 200px;
    p {
      color: white;
      font-family: "ClanProBold";
      font-size: 14px;
    }
    ul {
      color: white;
      font-family: "ClanPro";
      font-size: 12px;
      list-style: none;
      padding-left: 0;
      li {
        font-family: "ClanPro";
        font-size: 12px;
        strong {
          font-family: "ClanProBold";
          font-weight: normal;
          color: white;
        }
      }
    }
  }
  &__links {
    flex: 1;
    padding-left: 45px;
    ul {
      font-size: 12px;
      list-style: none;
      padding-left: 0;
      li {
        margin-bottom: 6px;
        a {
          color: white;
        }
      }
    }
  }
  &__signature {
    display: flex;
    width: 180px;
    span {
      align-self: flex-end;
      font-size: 8px;
      color: white;
    }
  }
  &__bayadere {
    margin: 0 125px;
  }
  &__baseline-container {
    display: flex;
    width: 100%;
    align-items: first baseline;
    width: 100%;
    justify-content: center;
  }
  .baseline {
    &__logo {
      width: 85px;
      // opacity: 0.3;
      margin-right: 55px;
    }
    &__text {
      font-family: "ClanProBold";
      font-size: 14px;
      color: black;
    }
  }
  &--mobile {
    margin-bottom: 80px;
    .footer__top {
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
    }
    .footer__bottom {
      padding: 20px;
      .footer__bayadere {
        margin: 0;
        width: 100%;
      }
      .footer__baseline-container {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 12px;
        }
      }
    }
  }
}
.footer--admin {
  .footer {
    margin-top: 0;
  }
}

@media screen and (max-width: 500px) {
  .footer {
    &--mobile {
      .footer__bottom {
        .footer__baseline-container {
          align-items: flex-start;
        }
      }
    }
  }
}

@media screen and (max-width: 350px) {
  .footer {
    &--mobile {
      .baseline {
        &__logo {
          margin-right: 35px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/Footer.vue